import { plural } from '@cian/utils';
import { isStudio } from '../../../utils/roomsCount';

export function getRoomsText(roomsCount: number) {
  return isStudio(roomsCount) ? 'Студия' : `${roomsCount} ${plural(roomsCount, ['комната', 'комнаты', 'комнат'])}`;
}
